import { ContentItem } from '@kentico/kontent-delivery';
import { SchemaBlockModel } from './schema-block-model';
import { ISchemaBlockProps } from '../components/schema-block/schema-block';
import get from 'lodash/get';

import { IProgressStepContentProps } from '../components/progress-steps/progress-step-content/progress-step-content';

export class ProgressStepContentModel extends ContentItem {
  get columnText1(): string {
    return get(this._config, 'elements.column_text_1.value', '');
  }

  get columnText2(): string {
    return get(this._config, 'elements.column_text_2.value', '');
  }

  get schemaBlocks(): ISchemaBlockProps[] {
    const getSchemaBlocks = get(
      this._config,
      'elements.schema_blocks.value',
      []
    );
    const transformSchemaBlocks = getSchemaBlocks
      ? getSchemaBlocks.map((schemaBlock: ISchemaBlock) =>
          SchemaBlockModel.create(schemaBlock)
        )
      : null;
    return transformSchemaBlocks;
  }

  public static create(data: IProgressStepContent): IProgressStepContentProps {
    const {
      columnText1,
      columnText2,
      schemaBlocks
    } = new ProgressStepContentModel(data);
    return {
      columnText1,
      columnText2,
      schemaBlocks
    };
  }
}
